
import Dialog from '@mui/material/Dialog';

import {Button, DialogContent, FormControlLabel, FormGroup, TextField} from "@mui/material";
import * as React from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import {useEffect, useState} from "react";

import {CemsNetworkStatusDataMart} from "./CemsNetworkStatusDataMart";
import Divider from '@mui/material/Divider';
import { StyledEngineProvider } from "@mui/material/styles";
import Tooltip from '@mui/material/Tooltip';
import {GridDataSelecter} from "../grid/GridDataSelecter";
import {FxDataGrid} from "../../grid/FxDataGrid";
import {AttrList} from "../../../datas/OpClass";
import {CemsEnergyUsageListGridDataMart} from "./CemsEnergyUsageListGridDataMart";
import {FxmsData} from "../../../datas/FxData";

export const CemsEnergyUsageListGrid = (props) => {
    const [open, setOpen] = useState(false)
    const [api, setApi] = useState('')
    const [designOptions, setDesignOptions] = useState({
        title:'button',bgColor:'#2eb2c7',textColor:'#000000',
    })
    const [value, setValue] = useState(0);

    const [data, setData] = useState([])

    const [columnList, setColumnList] = useState(null)
    const [rows, setRows] = useState([]);
    const [customColums, setCustomColumns] = useState({})



    useEffect(()=>{
        try {
            if(props.item.fxUiDashbItemAttrs){
                if(props.item.fxUiDashbItemAttrs.length >= 1 ){
                    let params = {}
                    let savedApi = props.item.fxUiDashbItemAttrs.find(x=>x.attrName =='api').attrVal
                    let savedColumns = JSON.parse(props.item.fxUiDashbItemAttrs.find(x=>x.attrName =='column').attrVal)
                    const columnsList = new AttrList("grid");
                    fetch(savedApi).then((response)=>{
                        return response.json()
                    }).then(datas=>{
                        datas.map((x,index)=>{
                            x.id = index
                        })
                        Object.keys(savedColumns).map(x=>{
                            let minWidth = 150
                            let curWidth = savedColumns[x].text.length*20
                            columnsList.addColumn(x,savedColumns[x].text,'text',curWidth < minWidth ? minWidth : curWidth)
                        })
                        setColumnList(columnsList)
                        setApi(savedApi)
                        setRows(datas)
                    })
                    let newOptions = {}
                    for(let key in designOptions){
                            newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal
                    }
                    setDesignOptions(newOptions)
                }
            }
        } catch (error) {
            console.log("error" + error);
            // FxWindow.alert("조회중 오류가 발행되었습니다.", true);
            setRows([]);
            setData([]);
        }
    },[])




    const handleApiChange = (selectedApi,customColum,data) => {
        const columnsList = new AttrList("grid");
        let filters = {}
        Object.keys(customColum).map(x=>{
            let minWidth = 150
            let curWidth = customColum[x].text.length*20

            columnsList.addColumn(x,customColum[x].text,'text',curWidth < minWidth ? minWidth : curWidth)
            if(x.search){
                let columnData = data.map(f => f[x])
                let uniqColumnData = columnData.filter((value, index, array) => array.indexOf(value) === index);
                filters[x] = {origin:x,alias:customColum[x].text,data:uniqColumnData}
            }
        })
        setColumnList(columnsList)
        setApi(selectedApi)
        setRows(data)
        //db에 저장하는부분
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'api',attrVal:selectedApi,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'column',attrVal:JSON.stringify(customColum),attrType:'string'})
        for(let key in designOptions){
            currentData.push({uiNo:props.item.uiNo,attrName:key,attrVal:designOptions[key]+'',attrType:'string'})
        }
        props.save(currentData,props.item.uiNo,props.item.opId)
    }

    const saveAndClose = () => {
        setOpen(false)

    }
    return (
        <StyledEngineProvider>
        <div>
            {props.editable ? <CemsEnergyUsageListGridDataMart options={{designOptions,setDesignOptions}} api={setApi} handleApiChange={handleApiChange} customColumns={setCustomColumns} />: ''}
            <Button sx={{width:'100%',backgroundColor:designOptions.bgColor,color:designOptions.textColor}} onClick={()=>setOpen(true)} variant={"contained"}>
                {designOptions.title}
            </Button>
            <Dialog onClose={saveAndClose} open={open} >
                <DialogContent>
                    {designOptions.title}
                    <Divider style={{backgroundColor:'white'}}/>
                    <div className="FxCrudDataGrid" style={{minWidth:'800px',minHeight: "500px"}}>
                        <FxDataGrid
                            attrList={columnList ? columnList.getList() : []}
                            rows={rows}
                            height={'450px'}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </div>
        </StyledEngineProvider>
    )
}
